import { render, staticRenderFns } from "./ExternalPartners.vue?vue&type=template&id=12bfc7fb&"
import script from "./ExternalPartners.vue?vue&type=script&lang=js&"
export * from "./ExternalPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports